import { render, staticRenderFns } from "./MetadadosCampoDinamicoAutocomplete.vue?vue&type=template&id=f717b4bc&"
import script from "./MetadadosCampoDinamicoAutocomplete.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./MetadadosCampoDinamicoAutocomplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VChip,VTooltip})
